<template>
	<div>
		<div class="box-detail-bae right-shadow white">
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="infoArmada">
					<v-col cols="12" class="px-4 pb-4">
						<div class="text-h6">Informasi Armada</div>
					</v-col>
					<div class="list-expedition">
						<div class="px-4"><v-divider></v-divider></div>
						<div class="px-4 py-5 text-body-2">
							<v-row>
								<v-col cols="2" class="pr-0">
									<v-img eager class="rounded-lg" src="/assets/user/profile-pict-menolak-big.png"></v-img>
								</v-col>
								<v-col cols="9" class="my-auto">
									<div class="font-size-11">M.Isa Idris</div>
									<div class="font-size-10 grey--text text--darken-1">Driver</div>
								</v-col>
								<v-col cols="2" class="pr-0 pt-0">
									<v-img eager class="rounded-lg" src="/assets/user/profile-pict-menolak-big.png"></v-img>
								</v-col>
								<v-col cols="9" class="my-auto pt-0">
									<div class="font-size-11">Rio</div>
									<div class="font-size-10 grey--text text--darken-1">Kenek</div>
								</v-col>
							</v-row>
						</div>
						<div class="px-4"><v-divider></v-divider></div>
						<div class="px-4 py-5 text-body-2">
							<v-row>
								<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Tipe Kendaraan</v-col>
								<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
									<div>:</div>
									<div class="font-weight-bold pl-2">L300</div>
								</v-col>
								<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Nopol</v-col>
								<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
									<div>:</div>
									<div class="font-weight-bold pl-2">D 8429 FL</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="statusExpedition">
					<v-col cols="12" class="px-4 pb-4">
						<div class="text-h6">Status Ekspedisi</div>
					</v-col>
					<div class="px-4"><v-divider></v-divider></div>
					<div class="pt-5">
						<div class="px-4 text-body-2 list-expedition">
							<v-row>
								<v-col cols="3" class="pr-4">
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-check-circle-outline</v-icon>
									</div>
									<div class="line-status-logistic mx-auto"></div>
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-truck-fast-outline</v-icon>
									</div>
									<div class="line-status-logistic mx-auto"></div>
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-truck-check-outline</v-icon>
									</div>
									<div class="line-status-logistic mx-auto"></div>
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-package-variant-closed</v-icon>
									</div>
								</v-col>
								<v-col cols="9" class="pl-0">
									<div class="pt-1 pb-3">
										<div class="text-body-2">Selesai Pengantaran</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 23.00</div>
									</div>
									<div class="pt-5 pb-3">
										<div class="text-body-2">Perjalanan ke Mobile Counter</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 22.00</div>
									</div>
									<div class="pt-5 pb-3">
										<div class="text-body-2">Berangkat dari RDC</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 17.00</div>
									</div>
									<div class="pt-5">
										<div class="text-body-2">Loading in produk</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 15.00</div>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="detailBalance">
					<v-col cols="12" class="px-4 pb-4">
						<div class="text-h6">Rincian Saldo</div>
					</v-col>
					<div class="px-4"><v-divider></v-divider></div>
					<div class="pt-5">
						<div class="px-4 text-body-2 list-expedition">
							<div class="text-body-2 font-weight-bold mb-3">Selasa 30 November 2020</div>
							<v-card elevation="3" class="px-3 mb-3 rounded-lg">
								<v-row>
									<v-col cols="2" class="pr-0">
										<v-img src="/assets/logistic/icons/isi-bensin.svg"></v-img>
									</v-col>
									<v-col cols="5" class="font-size-10 my-auto">
										<div>Isi Bensin</div>
										<div class="grey--text text--darken-1">
											<span>07.33</span>
											<span class="pl-3">15 L</span>
										</div>
									</v-col>
									<v-col cols="5" class="pl-0 my-auto text-right">
										<div class="font-weight-bold pink--text">-Rp 150.000</div>
									</v-col>
								</v-row>
							</v-card>
							<v-card elevation="3" class="px-3 mb-3 rounded-lg">
								<v-row>
									<v-col cols="2" class="pr-0">
										<v-img src="/assets/logistic/icons/makan.svg"></v-img>
									</v-col>
									<v-col cols="5" class="font-size-10 my-auto">
										<div>Makan</div>
										<div class="grey--text text--darken-1">06.00</div>
									</v-col>
									<v-col cols="5" class="pl-0 my-auto text-right">
										<div class="font-weight-bold pink--text">-Rp 3.150.000</div>
									</v-col>
								</v-row>
							</v-card>
							<v-card elevation="3" class="px-3 mb-3 rounded-lg">
								<v-row>
									<v-col cols="2" class="pr-0">
										<v-img src="/assets/logistic/icons/lainnya.svg"></v-img>
									</v-col>
									<v-col cols="5" class="font-size-10 my-auto">
										<div>Lainnya</div>
										<div class="grey--text text--darken-1">04.00</div>
									</v-col>
									<v-col cols="5" class="pl-0 my-auto text-right">
										<div class="font-weight-bold pink--text">-Rp 250.000</div>
									</v-col>
								</v-row>
							</v-card>
							<div class="pt-4"><v-divider></v-divider></div>
						</div>
					</div>
				</div>
			</transition>
			<div class="btn-nav-info-report">
				<div class="d-flex justify-center">
					<v-card elevation="5" width="90" :color="infoArmada ? 'primary lighten-1' : 'white'" class="cursor-pointer rounded-lg py-2 text-center" :class="infoArmada ? 'white--text' : 'grey--text'" @click="switchInfoArmada">
						<div class="font-size-10">Armada</div>
					</v-card>
					<v-card elevation="5" width="90" :color="statusExpedition ? 'primary lighten-1' : 'white'" class="cursor-pointer rounded-lg py-2 text-center ml-2" :class="statusExpedition ? 'white--text' : 'grey--text'" @click="switchStatusExpedition">
						<div class="font-size-10">Status</div>
					</v-card>
					<v-card elevation="5" width="90" :color="detailBalance ? 'primary lighten-1' : 'white'" class="cursor-pointer rounded-lg py-2 text-center ml-2" :class="detailBalance ? 'white--text' : 'grey--text'" @click="switchDetailBalance">
						<div class="font-size-10">Saldo</div>
					</v-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	data () {
		return {
			statusExpedition: false,
			detailBalance: false,
			infoArmada: true,
		}
	},
	methods: {
		switchInfoArmada() {
			this.infoArmada = true
			this.statusExpedition = false
			this.detailBalance = false
		},
		switchStatusExpedition() {
			this.infoArmada = false
			this.statusExpedition = true
			this.detailBalance = false
		},
		switchDetailBalance() {
			this.infoArmada = false
			this.statusExpedition = false
			this.detailBalance = true
		}
	}
};
</script>